import { Link, LinkProps } from "@mui/material";
import { SCancelButton } from "components";
import { SDialog, SDialogProps } from "components/parts";
import { labels } from "messages/labels";
import { forwardRef, useImperativeHandle, useState } from "react";

type Props = Partial<LinkProps> &
  Partial<Pick<SDialogProps, "dialog" | "handleSubmit">> &
  Partial<{
    label: string;
  }>;

export type SLinkHandler = {
  handleOpen: () => void;
};

export const SLink = forwardRef<SLinkHandler, Props>(
  ({ dialog, label, ...props }, ref): JSX.Element => {
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const handleSubmit = (data: any) => {
      props.handleSubmit?.call(this, data);
      setOpen(false);
    };

    useImperativeHandle(
      ref,
      () => ({
        handleOpen: handleOpen,
      }),
      []
    );

    const action = (
      <SCancelButton label={labels.buttons.close} onClick={handleClose} />
    );

    return (
      <>
        <Link
          onClick={(event) => {
            props.onClick?.call(this, event);
          }}
        >
          {label}
        </Link>
        {typeof dialog !== "undefined" && (
          <SDialog
            open={open}
            dialog={dialog}
            handleSubmit={handleSubmit}
            handleClose={handleClose}
            action={action}
          />
        )}
      </>
    );
  }
);
